// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import notification from 'antd/lib/notification';
import Alert from 'antd/lib/alert';
// APOLLO
import { graphql, compose } from 'react-apollo';
import getGoogleCalendarAuthUrl from 'ApolloClient/Mutations/getGoogleCalendarAuthUrl';
//
import GoogleCalConnected from './GoogleCalConnected';
import SectionHeader from 'components/text/SectionHeader';

class IntegrationsArea extends React.PureComponent {
  state = {
    disabled: false, // whether or not the form submit button is disabled
  };

  disableBtn = () => {
    this.setState({ disabled: true });
  };

  enableBtn = () => {
    this.setState({ disabled: false });
  };

  handleClick = async () => {
    this.disableBtn();

    try {
      const res = await this.props.getGoogleCalendarAuthUrl({ variables: {} });
      const { url } = res.data.getGoogleCalendarAuthUrl;
      // Redirect user to google auth page
      window.location = url;
    } catch (exc) {
      console.log(exc);
      notification.error({ message: exc });
    }

    this.enableBtn();
  };

  render() {
    const { currentUser } = this.props;

    return (
      <div style={{ width: 550, maxWidth: '100%', minHeight: 150 }}>
        <SectionHeader>HeyNed Third-party Integrations</SectionHeader>
        {currentUser.googleCalendarSet ? null : (
          <Alert
            message="Connect HeyNed with your Google Calendar."
            description={`By hitting Connect we'll create a new Google Calendar
              instance called "HeyNed" in your Google Calendar profile.
              Additionally, we'll automatically sync all events created in HeyNed
              with your Google Calendar HeyNed instance.`}
            type="info"
            style={{ margin: 10 }}
            closable
          />
        )}
        <div className="my1" />
        {currentUser.googleCalendarSet ? (
          <span>
            <GoogleCalConnected />
            {/* <b>Google Calendar Sync is currently activated!</b> */}
          </span>
        ) : (
          <img
            onClick={this.handleClick}
            alt="google-calendar"
            width="250"
            style={{ marginTop: 7, cursor: 'pointer' }}
            src="http://nwpana.org/wp-content/uploads/2016/04/google_nwpana-1024x158.jpg"
          />
        )}
        <div className="my3" />
      </div>
    );
  }
}

IntegrationsArea.propTypes = {
  currentUser: PropTypes.object.isRequired, // eslint-disable-line
  getGoogleCalendarAuthUrl: PropTypes.func.isRequired,
};

const enhance = compose(graphql(getGoogleCalendarAuthUrl, { name: 'getGoogleCalendarAuthUrl' }));

export default enhance(IntegrationsArea);



// WEBPACK FOOTER //
// ./src/routes/app-studio/IntegrationsArea/index.js